import { Injectable } from '@angular/core';
import { Province, ClubType, Gender, Grade, Ethnicity, HomeLanguage, ClubProjectType, ClubActivityType, AwardLevel, PaginationModel, PaginationResult } from '../models/shared-models';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError, tap } from 'rxjs/operators';
import { EventClass, EventEntry, EventRank } from '../models/eventsDto';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private httpClient: HttpClient) { }

  public GetProvinceList(): Observable<Array<Province>> {
    return this.httpClient.get<Province[]>(environment.apiUrl + 'Shared/GetAllProvinces').pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetGenders(): Observable<Gender[]> {
    return this.httpClient.get<Gender[]>(environment.apiUrl + 'Shared/GetAllGenders').pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetEnthnicity(): Observable<Ethnicity[]> {
    return this.httpClient.get<Ethnicity[]>(environment.apiUrl + 'Shared/GetAllEthnicities').pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetAllHomeLanguages(): Observable<HomeLanguage[]> {
    return this.httpClient.get<HomeLanguage[]>(environment.apiUrl + 'Shared/GetAllHomeLanguages').pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  GetEvents(pagination: PaginationModel) : Observable<PaginationResult<Event[]>>{
    let value = JSON.stringify(pagination);
    return this.httpClient.post<PaginationResult<Event[]>>(environment.apiUrl + 'Shared/GetAllEvents', value).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  RegisterForEvent(e: EventEntry) {
    let value = JSON.stringify(e);
    return this.httpClient.post<EventEntry>(environment.apiUrl + 'Shared/RegisterForEvent', value).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  UpdateEventEntryStatus(eventEntryId: number, status: any) {
    return this.httpClient.put(environment.apiUrl + `Shared/UpdateEventEntryStatus?eventEntryId=${eventEntryId}&status=${status}` , null).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  EventDownload(eventId: number){
    return this.httpClient.get(environment.apiUrl + 'Shared/GetEventDoc?eventId=' + eventId,
    { responseType: 'blob' });
  }
    
  public GetRanksByEventId(eventId: number): Observable<PaginationResult<EventRank[]>> { 
    var url = "Shared/GetRanksByEventId?eventId=" + eventId;

    return this.httpClient.post<PaginationResult<EventRank[]>>(environment.apiUrl + url, '{}').pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetClassesByEventId(eventId: number): Observable<PaginationResult<EventClass[]>> { 
    var url = "Shared/GetClassesByEventId?eventId=" + eventId;

    return this.httpClient.post<PaginationResult<EventClass[]>>(environment.apiUrl + url, '{"page": 0}').pipe(
      tap(),
      catchError(this.handleError)
    );
  }
  
  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occured: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
